module.exports = __webpack_public_path__ + "static/coupon-en-e891bbbf781f7fef556fe52cae40adb5.png";